import { useMemo } from 'react';

import { FilePlus2, ImagePlus, ZoomIn } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { Icon } from '@/_components';

export type OverlayProps = {
  disabled?: boolean;
  hasImage: boolean;
  hideIcon: boolean;
  type?: 'image' | 'file';
  onClick?: () => void;
};

export function OverLay({ disabled, hasImage, hideIcon, type = 'image', onClick }: OverlayProps) {
  const icon = useMemo(() => {
    switch (type) {
      case 'file': {
        return FilePlus2;
      }
      default: {
        return ImagePlus;
      }
    }
  }, [type]);

  return (
    <div
      className={twMerge(
        'group absolute inset-0 z-1 flex items-center justify-center bg-white/10 transition-all duration-300 dark:bg-gray-950/10',
        (hasImage || !disabled) && 'cursor-pointer'
      )}
      onClick={onClick}
    >
      <div
        className={`${hasImage ? 'opacity-0' : 'opacity-30'} ${
          (!disabled || hasImage) && hideIcon ? 'group-hover:opacity-100' : ''
        } text-accent-medium mt-1 flex size-7 items-center justify-center rounded-full bg-white/50 shadow-md transition-all duration-300`}
      >
        <Icon icon={hasImage && disabled ? ZoomIn : icon} />
      </div>
    </div>
  );
}
